<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Data Category</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                id="name"
                v-model="name"
                label="Name"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="Name"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                v-model="status"
                label="Status"
                :options="optionsStatus"
                required
                horizontal
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                :disabled="isSubmitting"
                @click="updateCategory"
              >Submit</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

const IN_USE_CATEGORY_ERROR = "This category cannot be deactivated";
const RESERVED_CATEGORY_ERROR = "Category Semua tidak dapat diubah";

export default {
  name: "CorporateCategoryEdit",
  data() {
    return {
      name: "",
      status: "",
      originalName: "",
      originalStatus: "",
      optionsStatus: ["ACTIVE", "INACTIVE"],
      isSubmitting: false,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    if (!this.authentication()) {
      return;
    }
    this.loadCategory();
  },
  methods: {
    authentication() {
      const token = localStorage.getItem("token");
      const data = token ? jwt.decode(token) : null;
      const allowedGroups = ["MARKETING", "ADMIN", "ADMINISTRATOR"];

      if (data && allowedGroups.includes(data.account_group)) {
        return true;
      }

      this.$router.push({ path: "/" });
      return false;
    },
    loadCategory() {
      const id = this.$route.params.id;

      axios
        .get(`${this.domain}/v1/corporate_action_category/data/${id}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const category = response && response.data ? response.data : {};
          this.name = category.name || "";
          this.status = category.status || "";
          this.originalName = this.name;
          this.originalStatus = this.status;
        })
        .catch((error) => {
          this.showError(this.getErrorMessage(error));
        });
    },
    goBack() {
      this.$router.push({ path: "/management/corporate-category" });
    },
    updateCategory() {
      if (this.isSubmitting) {
        return;
      }

      if (!this.name.trim()) {
        Swal.fire({
          text: "Category harap diisi",
          showCloseButton: true,
          confirmButtonText: "OK",
        });
        return;
      }

      this.isSubmitting = true;
      const id = this.$route.params.id;
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("status", this.status);

      axios
        .put(
          `${this.domain}/v1/corporate_action_category/update/${id}`,
          formData,
          {
            headers: {
              Authorization: this.token,
            },
          }
        )
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Category Data Updated",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.goBack();
          });
        })
        .catch((error) => {
          this.isSubmitting = false;
          const message = this.getErrorMessage(error);

          if (
            message === IN_USE_CATEGORY_ERROR ||
            message === RESERVED_CATEGORY_ERROR
          ) {
            this.name = this.originalName;
            this.status = this.originalStatus;
          }

          this.showError(message);
        });
    },
    getErrorMessage(error) {
      return (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.id
      );
    },
    showError(message) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: message || "Terjadi kesalahan saat memproses kategori.",
      });
    },
  },
};
</script>
